<template>
    <section class="col s12">

        <!-- Lista de bolsistas -->
        <div class="row">
            <div class="col s12">
                <p v-if="!bolsistasDaAcaoNoEditalAnterior || bolsistasDaAcaoNoEditalAnterior.length === 0" class="label-info-nao-encontrada">Não há bolsistas para essa ação no edital anterior!</p>

                <table class="responsive-table striped centered" v-else>
                    <thead>
                    <tr>
                        <th>
                            <span>Bolsista</span>
                        </th>
                        <th>
                            <span>Código do Programa</span>
                        </th>
                        <th>
                            <span>Bolsa</span>
                        </th>
                        <th>
                            <span>Trabalho Apresentado?</span>
                        </th>
                        <th>
                            <span>Relatorio</span>
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(bolsista, bolsista_i) in bolsistasDaAcaoNoEditalAnterior"
                        :key="bolsista_i">
                        <td>
                            <span>{{ bolsista.nome_bolsista }}</span>
                            <p><span style="font-size: small;">CPF: {{ bolsista.cpf_bolsista }}</span></p>
                            <p><span style="font-size: small;">E-mail: ({{ bolsista.email_bolsista }}</span></p>
                        </td>
                        <td>
                            <span>{{ bolsista.codigo_programa }}</span>
                        </td>
                        <td>
                            <span>{{ bolsista.codigo_tipo_bolsa }}</span> - <span>{{ bolsista.tipo_bolsa }}</span>
                        </td>
                        <td>
                            <div v-if="verificaSeAlunoApresentouTrabalhoNaSiac(bolsista.cpf_bolsista)">
                                <span class="new badge green" data-badge-caption="">Sim</span>
                            </div>

                            <span v-else class="new badge red" data-badge-caption="">Não se aplica</span>
                        </td>
                        <td>
                            <span v-if="!bolsista.hasOwnProperty('anexos') || !bolsista.anexos">Nenhum arquivo anexado...</span>

                            <a v-else
                               class="btn-flat blue-text"
                               :title="bolsista.anexos.nome_anexo"
                               :download="bolsista.anexos.nome_anexo"
                               :href="linkParaDownload(bolsista.anexos)">
                                <i class="material-icons left">file_download</i>
                                {{ truncarTexto(bolsista.anexos.nome_anexo) }}
                            </a>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="row">
            <!-- AVISO SOBRE CONFIGURAÇÃO DE "NÃO ATENDE" DE RELATÓRIO DE BOLSISTAS -->
            <div class="col s12">
                <div class="row">
                    <div class="col s12 blue-grey lighten-5">
                        <p>
                            <i class="material-icons blue-text text-darken-3 left">info</i>
                            <span style="font-weight: bold;">Informação!</span>

                            <span v-if="configuracaoDeRelatorioBolsista === 'cai_exigencia'">De acordo com a configuração da análise técnica, em caso de selecionado a opção
                                                                                             <strong>"Não Atende"</strong>
                                                                                             para o item
                                                                                             <strong>"Relatório de Bolsistas"</strong>
                                                                                             a inscrição cairá em
                                                                                             <strong>Exigência!</strong></span>

                            <span v-else>De acordo com a configuração da análise técnica, em caso de selecionado a opção
                                                                                             <strong>"Não Atende"</strong>
                                                                                             para o item
                                                                                             <strong>"Relatório de Bolsistas"</strong>
                                                                                             a inscrição será
                                                                                             <strong>Eliminada!</strong></span>
                        </p>
                    </div>
                </div>
            </div>

            <!-- VALIDAÇÃO DO RELATÓRIO DE BOLSISTAS ("NÃO SE APLICA", "ATENDE" OU "NÃO ATENDE") -->
            <div class="col s12">
                <p>
                    Relatório de Bolsistas?
                </p>

                <div class="col custom-col">
                    <label>
                        <input tipo="materialize"  name="relatorio_bolsistas_validacao"
                               class="with-gap"
                               type="radio"
                               id="rdRelBolsNaoSeAplica"
                               :disabled="allDisabled"
                               value="nao_se_aplica"
                               v-model="validacaoRelatorioBolsista" />
                        <span>Não se aplica</span>
                    </label>
                </div>

                <div class="col custom-col">
                    <label>
                        <input tipo="materialize"  name="relatorio_bolsistas_validacao"
                               :disabled="allDisabled"
                               class="with-gap"
                               type="radio"
                               id="rdRelBolsAtende"
                               value="atende"
                               v-model="validacaoRelatorioBolsista" />
                        <span>Atende</span>
                    </label>
                </div>

                <div class="col custom-col">
                    <label>
                        <input tipo="materialize"  name="relatorio_bolsistas_validacao"
                               :disabled="allDisabled"
                               class="with-gap"
                               type="radio"
                               id="rdRelBolsNaoAtende"
                               value="nao_atende"
                               v-model="validacaoRelatorioBolsista" />
                        <span>Não Atende</span>
                    </label>
                </div>

                <div class="col custom-col" v-if="exibeOpcaoEliminadoParaRelatorioESiac">
                    <label>
                        <input tipo="materialize"  name="relatorio_bolsistas_validacao"
                               :disabled="allDisabled"
                               class="with-gap"
                               type="radio"
                               id="rdRelBolsEliminado"
                               value="eliminado"
                               v-model="validacaoRelatorioBolsista" />
                        <span>Eliminado</span>
                    </label>
                </div>
            </div>
        </div>


        <div class="row">
            <!-- AVISO SOBRE CONFIGURAÇÃO DE "NÃO ATENDE" DE APRESENTAÇÃO DE TRABALHO NA SIAC -->
            <div class="col s12">
                <div class="row">
                    <div class="col s12 blue-grey lighten-5">
                        <p>
                            <i class="material-icons blue-text text-darken-3 left">info</i>
                            <span style="font-weight: bold;">Informação!</span>

                            <span v-if="configuracaoDeApresentacaoSiac === 'cai_exigencia'">De acordo com a configuração da análise técnica, em caso de selecionado a opção
                                                                                             <strong>"Não Atende"</strong>
                                                                                             para o item
                                                                                             <strong>"Apresentação de trabalho na SIAC"</strong>
                                                                                             a inscrição cairá em
                                                                                             <strong>Exigência!</strong></span>

                            <span v-else>De acordo com a configuração da análise técnica, em caso de selecionado a opção
                                                                                             <strong>"Não Atende"</strong>
                                                                                             para o item
                                                                                             <strong>"Apresentação de trabalho na SIAC"</strong>
                                                                                             a inscrição será
                                                                                             <strong>Eliminada!</strong></span>

                        </p>
                    </div>
                </div>
            </div>

            <!-- VALIDAÇÃO DA APRESENTAÇÃO DE TRABALHO NA SIAC ("NÃO SE APLICA", "ATENDE" OU "NÃO ATENDE") -->
            <div class="col s12">
                <p>
                    Apresentação de trabalho na SIAC?
                </p>

                <div class="col custom-col">
                    <label>
                        <input tipo="materialize"  name="apresentacao_na_siac_validacao"
                               class="with-gap"
                               type="radio"
                               id="rdApNaSiacNaoSeAplica"
                               :disabled="allDisabled"
                               value="nao_se_aplica"
                               v-model="validacaoApresentacaoTrabalhoSiac" />
                        <span>Não se aplica</span>
                    </label>
                </div>

                <div class="col custom-col">
                    <label>
                        <input tipo="materialize"  name="apresentacao_na_siac_validacao"
                               :disabled="allDisabled"
                               class="with-gap"
                               type="radio"
                               id="rdApNaSiacAtende"
                               value="atende"
                               v-model="validacaoApresentacaoTrabalhoSiac" />
                        <span>Atende</span>
                    </label>
                </div>

                <div class="col custom-col">
                    <label>
                        <input tipo="materialize"  name="apresentacao_na_siac_validacao"
                               :disabled="allDisabled"
                               class="with-gap"
                               type="radio"
                               id="rdApNaSiacNaoAtende"
                               value="nao_atende"
                               v-model="validacaoApresentacaoTrabalhoSiac" />
                        <span>Não Atende</span>
                    </label>
                </div>

                <div class="col custom-col" v-if="exibeOpcaoEliminadoParaRelatorioESiac">
                    <label>
                        <input tipo="materialize"  name="apresentacao_na_siac_validacao"
                               :disabled="allDisabled"
                               class="with-gap"
                               type="radio"
                               id="rdApNaSiacEliminado"
                               value="eliminado"
                               v-model="validacaoApresentacaoTrabalhoSiac" />
                        <span>Eliminado</span>
                    </label>
                </div>
            </div>
        </div>

    </section>
</template>

<script>
import file_uploads from "../../../utils/file_uploads";

export default {
    name: "at_relatorio_bolsista_edital_anterior",
    props: {
        allDisabled: {
            type: Boolean,
            default: false,
        },

        pTrabalhosApresentadosNaSiac: {
            type: Array,
            default: () => [],
        },

        pValidacaoRelatorioBolsista: {
            type: String,
            default: null,
        },
        pValidacaoApresentacaoTrabalhoSiac: {
            type: String,
            default: null,
        },
        configuracaoDeApresentacaoSiac: {
            type: String,
            default: null,
        },
        configuracaoDeRelatorioBolsista: {
            type: String,
            default: null,
        },
        exibeOpcaoEliminadoParaRelatorioESiac: {
            type: Boolean,
            default: false,
        },
        bolsistasDaAcaoNoEditalAnterior: {
            type: Array,
            default: () => { return [] },
        }
    },
    data() {
        return {
            validacaoRelatorioBolsista: this.pValidacaoRelatorioBolsista,
            validacaoApresentacaoTrabalhoSiac: this.pValidacaoApresentacaoTrabalhoSiac,
            trabalhosApresentadosNaSiac: this.pTrabalhosApresentadosNaSiac,
        }
    },
    watch: {
        pValidacaoRelatorioBolsista(newValue) {
            this.validacaoRelatorioBolsista = newValue
        },
        validacaoRelatorioBolsista(newValue) {
            this.$emit('update:pValidacaoRelatorioBolsista', newValue)
        },

        pValidacaoApresentacaoTrabalhoSiac(newValue) {
            this.validacaoApresentacaoTrabalhoSiac = newValue
        },
        validacaoApresentacaoTrabalhoSiac(newValue) {
            this.$emit('update:pValidacaoApresentacaoTrabalhoSiac', newValue)
        },

        pTrabalhosApresentadosNaSiac: {
            deep: true,
            handler(newValue){
                this.trabalhosApresentadosNaSiac = newValue
            }
        },
    },
    methods: {
        verificaSeAlunoApresentouTrabalhoNaSiac(cpf_aluno){
            if(!this.trabalhosApresentadosNaSiac && this.trabalhosApresentadosNaSiac.length === 0)
                return false

            let encontrou = false

            encontrou = _.findIndex(this.trabalhosApresentadosNaSiac, (trabalho) => {
                return trabalho.cpf_autores && trabalho.cpf_autores.includes(cpf_aluno)
            }) > -1

            return encontrou
        },

        linkParaDownload(anexo){
            return file_uploads.linkParaDownloadDeAnexosEmGeral(anexo)
        },

        truncarTexto(texto, caracteres = 10){
            return _.truncate(texto, {
                'omission': ' [...]',
                'length': caracteres,
            })
        },
    },
}
</script>

<style scoped>

</style>
